enum JobWorkerInterviewStatus {
	PendingConfirmation = 10,
	PartiallyConfirmed = 20,
	FullyConfirmed = 90,
	Completed = 91,
	Cancelled = 100
}

export default JobWorkerInterviewStatus;